import React, { Component } from "react";
import { Container, Row } from "reactstrap";
import Select from 'react-select'
import axios from 'axios'
import ContentLoader, { Facebook } from 'react-content-loader'

import SearchItem from './search-item';
import testPhoto from '../../assets/images/reviews/garil.jpg';

class Search extends Component {

  constructor(props) {
    super(props)
    this.endpoint = ''
    // this.endpoint = 'http://localhost:3001'
    this.token = ''
    this.tokenUUID = ''
    this.state = {
      provinces: {},
      tags: {},
      searchQuery: {
        term: '',
        province: '',
        speciality: ''
      },
      searchResults: [],
      searchResultsMessage: '',
      isSearching : false
    }
  }

  componentDidMount() {
    this.token = document.getElementById('token').value;
    this.tokenUUID = document.getElementById('tokenUUID').value;
    fetch(this.endpoint + '/api/list-provinces', {
      headers: {
        Authorization: this.token + ' ' + this.tokenUUID
      }
    })
    .then(response => response.json())
    .then(data => {
      this.setState({
        provinces: data
      })
    })

    fetch(this.endpoint + '/api/list-dermatologist-tags', {
      headers: {
        Authorization: this.token + ' ' + this.tokenUUID
      }
    })
    .then(response => response.json())
    .then(data => {
      this.setState({
        tags: data
      })
    })

    if (this.props.listing == 'all')
    {
      let searchQuery = this.state.searchQuery
      this.fetchSearchResults(searchQuery)
    }
  }

  handleProvinceChange = (event) => {
    let searchQuery = this.state.searchQuery
    searchQuery.province = event.value

    window.dataLayer.push({
      event: 'search',
      eventProps: {
          category: 'user-action',
          action: 'search',
          label: 'province',
          value: searchQuery.province
      }
    })

    this.setState({
      searchQuery: searchQuery
    }, () => {
      this.fetchSearchResults(searchQuery)
    })
  }

  handleSpecialityChange = (event) => {
    let searchQuery = this.state.searchQuery
    searchQuery.speciality = event.value

    window.dataLayer.push({
      event: 'event',
      eventProps: {
          category: 'user-action',
          action: 'search',
          label: 'speciality',
          value: searchQuery.speciality
      }
    })

    this.setState({
      searchQuery: searchQuery
    }, () => {
      this.fetchSearchResults(searchQuery)
    })
  }

  handleDermaChange = (event) => {
    let searchQuery = this.state.searchQuery
    searchQuery.term = event.target.value
    this.setState({
      searchQuery: searchQuery
    }, () => {
      this.fetchSearchResults(searchQuery)
    })
  }

  clearSearch = (event) => {
    this.setState({
      searchQuery: {},
      searchResultsMessage: 'Search cleared. You may now start a new search.',
      searchResults: {}
    })
    this.refs.nameInput.value = ''
  }

  fetchSearchResults = (query) => {
    const searchURL = this.endpoint + '/api/dermatologist-search'
    // Cancel the previous request before making a new request
    if (this.cancel) {
      this.cancel.cancel();
    }
    this.cancel = axios.CancelToken.source()

    this.setState({
      isSearching: true
    })
    axios
      .post(searchURL, query, {
        cancelToken: this.cancel.token,
        headers: {
          Authorization: this.token + ' ' + this.tokenUUID,
          ContentType: 'application/json'
        }
      })
      .then((response) => {
        const noResultsMessage = !response.data.length
				    ? 'No dermatologists found that matches your search. Please try again.'
				    : '';
        this.setState({
          searchResults: response.data,
          searchResultsMessage: noResultsMessage,
          isSearching: false
        })

      })
      .catch((error) => {
        if (axios.isCancel(error) || error) {
          this.setState({
            searchResultsMessage: 'Unable to search for a dermatologist. Please check your internet connection and try again.',
            isSearching: false,
          })
        }
      })
  }

  renderSearchResults = () => {
    const {searchResults} = this.state
    if (Object.keys(searchResults).length && searchResults.length) {
      return (
        <div className="col-12">
          {
            searchResults.map((result) => {
              return (
                <SearchItem name={result.name} destination={result.link} photo={result.photo} category="Clinical Dermatologist" qualifications={result.qualifications} address={result.address} blurp={result.bio} vacation={result.vacation} vacationuntil={result.vacationuntil} />
              )
            })
          }
        </div>
      )
    }
  }

  render() {
    const customStyles = {
      control: (provided, state) => ({
        ...provided,
        borderColor: state.isFocused ? '#D1BA83' : '#CCCCCC',
        boxShadow: state.isFocused ? '0 0 0 1px #D1BA83' : '0 0 0 0px #CCCCCC',
        // borderColor: '#D1BA83',
        // boxShadow: '0 0 0 1px #D1BA83',
        '&:hover': {
          borderColor: '#D1BA83',
          boxShadow: '0 0 0 1px #D1BA83'
        },
        '&:focus': {
          borderColor: '#D1BA83',
          boxShadow: '0 0 0 1px #D1BA83'
        },
        '&:active': {
          borderColor: '#D1BA83',
          boxShadow: '0 0 0 1px #D1BA83',
        },
        '&:visited': {
          borderColor: '#D1BA83',
          boxShadow: '0 0 0 1px #D1BA83',
        },
      }),
      singleValue: (provided, state) => {
        const opacity = state.isDisabled ? 0.5 : 1;
        const transition = 'opacity 300ms';

        return { ...provided, opacity, transition };
      },
      menu: (provided, state) => ({
        ...provided,
        position: 'relative',
        textAlign: 'left',
        zIndex: 9999,
      })
    }

    const provinces = this.state.provinces
    const tags = this.state.tags
    const {searchResultsMessage, isSearching} = this.state
    const displayOptions = this.props.listing == 'all' ? 'section pb-5 pt-4 position-relative d-block' : 'section pb-5 pt-5 position-relative d-none d-lg-block'
    return (
      <React.Fragment>
        <section id="search" className={displayOptions} >
          <Container className="pb-3">
            <div className="text-center mb-3">
              <h5>Find a dermatologist</h5>
            </div>
            <div className="row d-none d-lg-flex">
              <div className="col-3 mb-2 mx-auto">
                <Select styles={customStyles} placeholder="Select province" className="w-100" options={provinces} onChange={this.handleProvinceChange} />
              </div>
              <div className="col-3 mb-2 mx-auto">
                <Select styles={customStyles} placeholder="Select speciality" className="w-100" options={tags} onChange={this.handleSpecialityChange} />
              </div>
              <div className="col-4 mb-2 mx-auto">
                <input type="text" className="form-control" placeholder="Name of dermatologist" onChange={this.handleDermaChange} ref="nameInput" />
              </div>
              <div className="col-2 mx-auto text-center">
                <a href="#clear-search" className="text-dark d-block mt-1" onClick={this.clearSearch}>Clear search</a>
              </div>
            </div>

            <div className="horizontal-filters d-lg-none">
              <div className="row text-center pb-3">
                <div className="col-7">
                  <Select styles={customStyles} placeholder="Select province" className="w-100" options={provinces} onChange={this.handleProvinceChange} />
                </div>
                <div className="col-7">
                  <Select styles={customStyles} placeholder="Select speciality" className="w-100" options={tags} onChange={this.handleSpecialityChange} />
                </div>
                <div className="col-9">
                  <input type="text" className="form-control" placeholder="Name of dermatologist" onChange={this.handleDermaChange} ref="nameInput" />
                </div>
              </div>
            </div>
            <div className="col-12 mt-2 text-center  d-lg-none">
              <a href="#clear-search" className="text-link d-block mt-1" onClick={this.clearSearch}>Clear search</a>
            </div>
          </Container>
          <Container>
            <div className="row derma-listing mt-3">
              {
                 isSearching
                 ? <div className="col-12">
                      <p className="text-center">
                        Searching our dermatologists...
                      </p>
                      <div className="col-12 col-md-10">
                        <ContentLoader />
                      </div>
                    </div>
                 : ''
              }
              { isSearching && <div className="col-12 text-center"><p></p></div>}
              { (searchResultsMessage && !isSearching) && <div className="col-12"><p className="message">{searchResultsMessage}</p></div> }
              { this.renderSearchResults() }
            </div>
          </Container>
        </section>
      </React.Fragment>
    );
  }
}

export default Search;
